import * as React from "react"
import "../../global.css"
import Header from "../components/Header/header"
import { HomeHeader } from "../page-components/home/HomeHeader"
import { EmployersSection } from "../page-components/home/EmployersSection"
import { JobLinkedCourses } from "../page-components/home/JobLinkedCourses"
// import { HomeSkilledBanner } from "../page-components/home/HomeSkilledBanner"
import { HomePotentialProfessional } from "../page-components/home/HomePotentialProfessional"
// import { ImpactfulPartnerShips } from "../page-components/home/ImpactfulPartnerships"
import { RecognizedExcellence } from "../page-components/home/RecognizedExcellence"
import { SkillInstitutesLocation } from "../page-components/home/SkillInstitutesLocation"
import NewsSection from "../page-components/home/NewsSection"
import { GovernmentPartnerships } from "../page-components/home/GovernmentPartnerships"
import { DreamJob } from "../page-components/home/DreamJob"
import Footer from "../components/Footer/footer"
import Seo from "../components/seo"
// import HomeTestimonial from "../page-components/home/Testimonial"

const IndexPage = () => {
  const [slideIndex, setSlideIndex] = React.useState(0)
  return (
    <>
      <div style={{
        background: slideIndex%3 == 0 ? '#F4F5FF' : slideIndex % 3 == 1 ? '#E1E4FF': '#E2F2FE',
        transition: "background-color 500ms ease-in-out, transform 500ms ease-in-out",
      }}>
        <NewsSection />
        <Header />
        <div className="container mx-auto px-4 md:pb-16 pb-6">
          <HomeHeader setSlideIndex={setSlideIndex}/>
        </div>
      </div>
      <div className="md:py-8 py-6">
        <EmployersSection />
      </div>
      <div className="md:py-8 py-6 ">
        <JobLinkedCourses />
      </div>
      <div className="md:py-8 py-6 ">
        <SkillInstitutesLocation />
      </div>

      <div className="md:py-8 py-6 ">
        <DreamJob />
      </div>

      {/* <div className="md:py-8 py-6 ">
        <HomeSkilledBanner />
      </div> */}
      <div className="md:py-8 py-6 ">
        <HomePotentialProfessional />
      </div>
      {/* <div className="md:py-8 py-6 ">
        <HomeTestimonial />
      </div> */}
      {/*  <div className="md:py-8 py-6 ">
        <ImpactfulPartnerShips />
      </div> */}
      <div className="md:py-8 py-6 ">
        <GovernmentPartnerships />
      </div>
      <div className="md:py-8 py-6 ">
        <RecognizedExcellence />
      </div>
      <Footer />
    </>
  )
}

export const Head = () => (
  <Seo
    title="Best vocational training institute - Learnet Skills"
    description="Learnet institute of skills is leading institute in offering job linked, in demand skill based courses with placement assistance in centers across India"
  >
    <link rel="canonical" href="https://www.learnetskills.com/" />
  </Seo>
)

export default IndexPage
